module.exports = __webpack_public_path__ + "img/setting.5fbe884d.svg";